import { call, put } from 'typed-redux-saga'
import { budgetApiClient } from '../../api/budgetApiClient'
import {
	deleteSmartCheckSessionSuccess,
	deleteSmartCheckSessionFailure,
} from '../actions/smartCheckSessionDeletionActions'

export function* deleteSmartCheckSession() {
	try {
		yield* call(budgetApiClient.deleteSmartCheckSession)
		yield put(deleteSmartCheckSessionSuccess())
	} catch (error: any) {
		yield put(
			deleteSmartCheckSessionFailure({
				errorText: error.name + ': ' + error.message,
				errorCode: error.errorCode,
				innerErrors: undefined,
			}),
		)
	}
}
